import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as Icon } from '../assets/icon.svg';
// import { useEffect, useState } from 'react';
import { ReactComponent as NavBg } from '../assets/bg-nav.svg';

const Navbar = () => {
    // const [scrollY, setScrollY] = useState(0);
    const location = useLocation();
    // useEffect(() => {
    //     window.addEventListener('scroll', (e) => {
    //         setScrollY(window.scrollY);
    //     })
    // }, [])

    const isHome = () => location.pathname === '/';

    // const renderBackground = () => {
    //     if (scrollY > (window.innerHeight / 2)) {
    //         return 'navbar-bg'
    //     } else {
    //         return ''
    //     }
    // }

    return (
        <nav className="navbar">
            <NavBg id='nav-bg' />
            <div className="navbar__content">
                <div className="navbar__left">
                    <Link to='/'>
                        <Icon />
                    </Link>
                </div>
                <div className={`navbar__right ${isHome() ? '' : 'navbar__right-white'}`}>
                    <Link to='/'>Home</Link>
                    <Link to='/privacy'>Policy</Link>
                    <Link to='/terms'>Terms</Link>
                    <Link to='/about'>About</Link>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;